import React from 'react'
import i1 from "../img/img1.png";
import { motion } from "framer-motion";


export default function Intro() {
  return (
    <div>
      <div
        id='homeintro'
       
        className="max-w-screeen-lg mx-auto grid grid-rows md:grid-flow-col 
         items-center justify-center h-full  md:flex-row "
      >
        <div className="flex flex-col justify-center ml-10 h-full md:ml-10">
          <p className="py-4 max-w-md">Welcome to my portfolio</p>
          <motion.h2
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-2xl sm:text-4xl font-bold md:text-4xl mt-2"
          >
            Hi! I'm a Full Stack Developer
            <br /> and UI/UX Designer
          </motion.h2>

          
        </div>

        <div className="col-span-2 md:col-span-1">
          <img src={i1} alt="IMG1" className="mx-auto w-2/3 md:w-full" />
        </div>
      </div>

    </div>
  )
}